import React from 'react';

interface TableElementProps {
  table: string[][];
}

export const TableElement: React.FC<TableElementProps> = ({ table }) => {
  return (
    <div className="ds-scrollbar overflow-x-auto rounded-ds-8 border border-ds-100">
      <table className="ds-table">
        <tbody>
          {table.map((row: string[], rowIndex: number) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td key={cellIndex} className={rowIndex === 0 ? 'bg-ds-subtle font-bold text-ds-700' : 'text-ds-700'}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
